import { apiGateway } from "@/shared/apiGateway";

const getContractorListing = context => {
  return apiGateway
    .apiGatewayGET("api/data-management/contractors")
    .then(data => {
      return context.commit("set_contractor_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Contractors"], {
        root: true
      });
    });
};

const getContractorRegionDropdownOptions = context => {
  return apiGateway
    .apiGatewayGET(
      "api/data-management/contractors/contractor-regions-dropdown-options"
    )
    .then(data => {
      context.commit("set_contractor_region_dropdown", data);
    })
    .catch(error => {
      console.error(error);
      context.commit("STATINSP_SETSTATINSP", undefined);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        [
          "Error getting Contractor Region Dropdown Options - " +
            error.response.data
        ],
        {
          root: true
        }
      );
    });
};

const getContractorDetails = (context, id) => {
  return apiGateway
    .apiGatewayGET("api/data-management/contractors/" + id)
    .then(data => {
      context.commit("set_region_listing", data.contractorRegions);
      delete data.contractorRegions;
      context.commit("set_contractor", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Contractor"], {
        root: true
      });
    });
};

const createContractor = (commit, contractor) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/contractors", contractor)
    .then(data => {
      return data;
    });
};

const updateContractor = (commit, form) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/contractors", form)
    .then(data => {
      return data;
    });
};

const getContractorRegionListing = (context, contractorId) => {
  return apiGateway
    .apiGatewayGET(
      "api/data-management/contractorregions?contractorId=" + contractorId
    )
    .then(data => {
      return context.commit("set_region_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting contractor regions"],
        { root: true }
      );
    });
};

const getContractorRegionDetails = (context, id) => {
  return apiGateway
    .apiGatewayGET("api/data-management/contractorRegions/" + id)
    .then(data => {
      context.commit("set_contacts_listing", data.contractorContacts);
      delete data.contractorContacts;
      context.commit("set_region", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Region"], {
        root: true
      });
    });
};

const createRegion = (commit, contractor) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/contractorRegions", contractor)
    .then(data => {
      return data;
    });
};

const updateRegion = (commit, form) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/contractorRegions", form)
    .then(data => {
      return data;
    });
};

const getContractorContactDetails = (context, id) => {
  return apiGateway
    .apiGatewayGET("api/data-management/contractorContacts/" + id)
    .then(data => {
      context.commit("set_contact", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Region"], {
        root: true
      });
    });
};

const createContact = (commit, contact) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/contractorContacts", contact)
    .then(data => {
      return data;
    });
};

const updateContact = (commit, form) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/contractorContacts", form)
    .then(data => {
      return data;
    });
};

const deleteContact = (context, id) => {
  return apiGateway
    .apiGatewayDELETE("api/data-management/contractorContacts/" + id)
    .then(() => {
      context.commit("delete_contact_by_id", id);
      return;
    });
};

export default {
  createContact,
  createContractor,
  createRegion,
  deleteContact,
  getContractorContactDetails,
  getContractorDetails,
  getContractorListing,
  getContractorRegionDropdownOptions,
  getContractorRegionDetails,
  getContractorRegionListing,
  updateContact,
  updateContractor,
  updateRegion
};
